module.exports = __webpack_public_path__ + "media/components/Application/FormTags/Categories/31-3bad581611d455d0ea35d7eb371f42c6.png";